import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  const steps = [{
    phase: 'ANTES',
    title: 'Preguntas correctas',
    desc: 'Cómo calificar al cliente antes de perder tiempo cotizando.'
  }, {
    phase: 'DURANTE',
    title: 'Presentar valor',
    desc: 'Estructuras probadas para que el precio parezca una inversión.'
  }, {
    phase: 'DESPUÉS',
    title: 'Seguimiento inteligente',
    desc: 'Qué decir cuando no responden, sin sonar desesperado.'
  }];
  return <section className="bg-cream text-navy py-24 px-5" data-id="element-88">
      <div className="max-w-5xl mx-auto" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="font-playfair text-3xl md:text-5xl font-bold mb-4" data-id="element-91">
            Antes · Durante · Después
          </h2>
          <p className="font-dmsans text-navy/60 uppercase tracking-widest text-sm font-bold" data-id="element-92">
            El Método Completo
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-93">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white border border-gold/20 p-8 rounded shadow-sm hover:shadow-md transition-shadow" data-id="element-94">
              <span className="font-dmsans text-gold font-bold text-sm tracking-widest uppercase block mb-4" data-id="element-95">
                {step.phase}
              </span>
              <h3 className="font-playfair text-2xl font-bold mb-3 text-navy" data-id="element-96">
                {step.title}
              </h3>
              <p className="font-dmsans text-navy/70 leading-relaxed" data-id="element-97">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}